// components/CarouselItem.tsx

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface CarouselItemProps {
  imageSrc: string;
  text: string;
}

const Item = styled(Box)(({ theme }) => ({
  width: '44.87vw',
  height: '78px',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: 'rgba(22, 29, 29, 0.66)',
  marginRight: '8px',
  paddingTop: '1vh',
  paddingBottom: '1vh',
  borderRadius: '4px',
  border: '1px solid #375A5B',
  gap: '0.7vh',

  [theme.breakpoints.up('sm')]: {
    width: '424px',
    height: '166px',
    borderRadius: '8px',
    border: '1px solid #1D6D6C',
    backdropFilter: 'blur(4px)',
  },
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  height: '50px', // 기본 높이 (xs 이하)
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  flexShrink: 0, // img 크기 고정
  [theme.breakpoints.up('sm')]: {
    height: '100px', // sm 이상에서 높이 조정
  },
}));

const ItemText = styled(Box)(({ theme }) => ({
  color: '#FFF',
  textAlign: 'center',
  fontFamily: 'Pretendard',
  fontSize: '0.675rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '0.625rem',
  flex: 1,

  [theme.breakpoints.up('sm')]: {
    fontSize: '22px',
    flex: 0.8,
    display: 'flex',
    padding: '10px',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const CarouselItem = ({ imageSrc, text }: CarouselItemProps) => {
  return (
    <Item>
      <ImageContainer
        sx={{
          flex: { xs: 1, sm: 1.2 }, // 반응형 flex는 sx에서 처리
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          sx={{
            maxHeight: '100%',
            maxWidth: '100%',
            height: 'auto',
            width: 'auto',
            display: 'block',
            mt: 2,
          }}
        />
      </ImageContainer>
      <ItemText>{text}</ItemText>
    </Item>
  );
};

export default CarouselItem;
